module.exports = __webpack_public_path__ + "img/education_ss.9340ac71.png";